'use client';

import { UserProfileSection } from '../../components/UserProfile/UserProfileSection';
import { createSection } from '../createSection';

export const UserProfileProfileSection = createSection('UserProfileProfileSection', UserProfileSection);
